import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from '@/plugins/router';
import vant from 'vant';
import store from '@/plugins/store';
import inject from '@/plugins/inject'; // 注意顺序，可能编译错乱，导致线上发布异常
// 引入echarts
// import VCharts from 'v-charts';
// import echarts from 'echarts';
import axiosOrg from 'axios';
import globalMy from '../src/global/global.js';
// Vue.prototype.$echarts = echarts;
Vue.prototype.$global = globalMy;
Vue.prototype.$axios = axiosOrg; // fanqz add支持原生
// import dataV from '@jiaminghi/data-view';
// Vue.use(dataV);
Vue.config.productionTip = false;
// import iView from 'iview'
import iView from 'view-design';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false;

Vue.use(Antd);
import ModalBox from '@/plugins/modal/index';
// import 'iview/dist/styles/iview.css'
import 'view-design/dist/styles/iview.css';
// import './index.less' //设置主题文件
import './static/theme/theme.less';
// Import component
// Import stylesheet
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// 引入bootstrap
// import BootstrapVue from 'bootstrap-vue';
// Vue.use(BootstrapVue);
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
/*  add gaode map  */
// import AMap from 'vue-amap'
// import VueAMap from 'vue-amap'; // 注意不要和 AMap原始名称覆盖
// 引入quill
// import VueQuillEditor from 'vue-quill-editor';
// import QuillImageDropModule from 'quill-image-drop-module'
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// import VideoPlayer from 'vue-video-player';
// import VideoContribHls from 'videojs-contrib-hls';
// import 'video.js/dist/video-js.css';
// import 'vue-video-player/src/custom-theme.css';
import vueSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
// import VueWechatTitle from 'vue-wechat-title';
// Vue.use(VueWechatTitle);
// import VueClipboard from 'vue-clipboard2';
// Vue.use(VueClipboard);
// import vcolorpicker from 'vcolorpicker';
// Vue.use(vcolorpicker);
Vue.use(vueSwiper);
// Vue.use(VueAMap);
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
//   ak: 'MMylOo7huB82Xr0BRGMspzjLLDwumj6f'
// })
// Init plugin
global.vbus = new Vue();
Vue.config.productionTip = false;
// Vue.use(VideoPlayer);
// Vue.use(VideoContribHls);
Vue.use(inject);
Vue.use(ModalBox, {componentName: 'modal-box'});
// Vue.use(echarts);
// Vue.use(VueQuillEditor);
Vue.use(iView);
Vue.use(ElementUI).use(vant);
// Vue.use(VCharts);
// Vue.use(QuillImageDropModule)
/* eslint-disable no-new */

// 消息提示配置，duration为提示时长
Vue.prototype.$Message.config({
  top: 70,
  duration: 2
});
Vue.prototype.$Notice.config({
  top: 70,
  duration: 3
});
// 设置session/localStorage实时获取数据更新
// type：1--local   2--session
Vue.prototype.$addStorageEvent = function (type, key, data) {
  if (type === 1) {
    // 创建一个StorageEvent事件
    let newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, data);
  }
  // 创建一个StorageEvent事件
  let newStorageEvent = document.createEvent('StorageEvent');
  const storage = {
    setItem: function (k, val) {
      sessionStorage.setItem(k, val);
      // 初始化创建的事件
      newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
      // 派发对象
      window.dispatchEvent(newStorageEvent);
    }
  };
  return storage.setItem(key, data);

};
// VueAMap.initAMapApiLoader({
//   key: '9471127d63eea244081947243a021806',
//   plugin: ['AMap.Geocoder', 'AMap.Geolocation', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   v: '1.4.5',
//   uiVersion: '1.0.11'
// });
window.VueInstance = new Vue({
  el: '#app',
  router,
  store,
  ...App
});
